import { getSessionUUID } from '../components/lib/AuthToken';
import logger from "../utils/logger";


// Send a test push notification to a specific user's devices
export const send_test_notification = async (profile_id, title, body) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({ profile_id, title, body })
        };

        const response = await fetch('/dev/send_test_notification', requestOptions);
        const responseBody = await response.json();

        return {
            message: responseBody.message || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error('Error sending test notification:', err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};


// Fetch notifications
export const fetch_notifications = async () => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            }
        };

        const response = await fetch('/dev/fetch_notifications', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching notifications:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

// Update notifications
export const update_notifications = async (requestData) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify(requestData)
        };

        const response = await fetch('/dev/update_notifications', requestOptions);
        const responseBody = await response.json();

        return {
            message: responseBody.message || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error updating notifications:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

// Get all users
export const get_all_users = async () => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            }
        };

        const response = await fetch('/dev/get_all_users', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching users:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

// Defect Management Functions

// Get alcohol testing configuration
export const get_alcohol_test_config = async () => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            }
        };

        const response = await fetch('/alcohol_testing/get_config', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching alcohol test config:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

// Update alcohol testing configuration
export const update_alcohol_test_config = async (passPercentage, enabled) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({
                pass_percentage: passPercentage,
                enabled: enabled
            })
        };

        const response = await fetch('/alcohol_testing/update_config', requestOptions);
        const responseBody = await response.json();

        return {
            message: responseBody.message || 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error updating alcohol test config:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

// =====================================================
// Fuel Surcharge Functions
// =====================================================

export const get_fuel_surcharge_rates = async () => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
        };

        const response = await fetch('/dev/get_fuel_surcharge_rates', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error fetching fuel surcharge rates:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

export const update_fuel_surcharge_rates = async (lowPercentage, mediumPercentage, highPercentage, updatedBy) => {
    try {
        const sessionToken = await getSessionUUID();

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${sessionToken}`
            },
            body: JSON.stringify({
                low_percentage: lowPercentage,
                medium_percentage: mediumPercentage,
                high_percentage: highPercentage,
                updated_by: updatedBy || 'user'
            })
        };

        const response = await fetch('/dev/update_fuel_surcharge_rates', requestOptions);
        const responseBody = await response.json();

        return {
            message: 'Request successful',
            status: response.status,
            data: responseBody || null,
        };
    } catch (err) {
        logger.error("Error updating fuel surcharge rates:", err);
        return {
            message: err.message || 'An error occurred',
            status: 500,
        };
    }
};

// =====================================================
// SOPs & RAMS Document Management
// =====================================================

export const upload_document = async (file, docType, displayName) => {
    try {
        const sessionToken = await getSessionUUID();

        const formData = new FormData();
        formData.append('file', file);
        formData.append('doc_type', docType);
        formData.append('display_name', displayName || file.name);

        const response = await fetch('/dev/documents/upload', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${sessionToken}` },
            body: formData,
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Upload successful', status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error uploading document:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const upload_logo = async (file) => {
    try {
        const sessionToken = await getSessionUUID();
        const formData = new FormData();
        formData.append('file', file);
        const response = await fetch('/dev/logo/upload', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${sessionToken}` },
            body: formData,
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Upload successful', status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error uploading logo:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const delete_logo = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/logo/delete', {
            method: 'DELETE',
            headers: { 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Deleted', status: response.status };
    } catch (err) {
        logger.error("Error deleting logo:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const list_documents = async (docType = null) => {
    try {
        const sessionToken = await getSessionUUID();
        const url = docType ? `/dev/documents/list?type=${docType}` : '/dev/documents/list';

        const response = await fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error listing documents:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const get_document_url = async (filePath) => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch('/dev/documents/url', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ file_path: filePath }),
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error getting document URL:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const delete_document = async (filePath) => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch('/dev/documents/delete', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ file_path: filePath }),
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Deleted', status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error deleting document:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const get_document_qr_sheet = async (filePath, displayName, docType) => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch('/dev/documents/qr_sheet', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ file_path: filePath, display_name: displayName, doc_type: docType }),
        });

        if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            return { status: response.status, error: body.error || 'Failed to generate QR sheet' };
        }

        const blob = await response.blob();
        const contentDisposition = response.headers.get('Content-Disposition') || '';
        const nameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
        const fileName = nameMatch ? nameMatch[1] : `QR_Sheet_${displayName || 'document'}.pdf`;
        return { status: 200, data: blob, fileName };
    } catch (err) {
        logger.error("Error generating QR sheet:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

// =====================================================
// Privilege Management
// =====================================================

export const get_admin_profiles = async () => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch('/dev/get_admin_profiles', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching admin profiles:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const set_super_admin = async (profileId, value) => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch('/dev/set_super_admin', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ profile_id: profileId, value }),
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Updated', status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error setting super admin:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const get_permissions_users = async () => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch('/dev/permissions/get_users', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching permissions users:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const update_user_permissions = async (updates) => {
    try {
        const sessionToken = await getSessionUUID();

        const response = await fetch('/dev/permissions/update', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ updates }),
        });
        const responseBody = await response.json();
        return { status: response.status, message: responseBody.message || 'Updated', data: responseBody };
    } catch (err) {
        logger.error("Error updating user permissions:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

// =====================================================
// Feature Flags
// =====================================================

export const get_features = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/get_features', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching features:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const update_feature = async (featureName, value) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/update_feature', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ feature_name: featureName, value }),
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Updated', status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error updating feature:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

// =====================================================
// Active KPI Visibility
// =====================================================

export const get_active_kpis = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/get_active_kpis', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching active KPIs:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const update_active_kpi = async (kpiName, value) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/update_active_kpi', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ kpi_name: kpiName, value }),
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Updated', status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error updating active KPI:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

// =====================================================
// Company Variables
// =====================================================

export const get_company_vars = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/get_company_vars', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching company vars:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const update_company_vars = async (vars) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/update_company_vars', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify(vars),
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Updated', status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error updating company vars:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const get_depot_locations = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/depot_locations', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching depot locations:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const save_depot_location = async (location) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/depot_locations', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify(location),
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error saving depot location:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const deactivate_depot_location = async (locationId) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/dev/depot_locations/${locationId}`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error deactivating depot location:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const get_invoice_settings = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/invoice_settings', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching invoice settings:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const update_invoice_settings = async (settings) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/invoice_settings', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify(settings),
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Updated', status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error updating invoice settings:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const update_backup_config = async (config) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/update_backup_config', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify(config),
        });
        const responseBody = await response.json();
        return { message: responseBody.message || 'Updated', status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error updating backup config:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const test_backup_connection = async (host, port, api_key) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/backup/test_connection', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ host, port, api_key }),
        });
        const responseBody = await response.json();
        return { success: responseBody.success, message: responseBody.message || responseBody.error, status: response.status };
    } catch (err) {
        logger.error("Error testing backup connection:", err);
        return { success: false, message: err.message || 'An error occurred', status: 500 };
    }
};

export const run_backup_now = async (mode = 'incremental') => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/backup/run_now', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ mode }),
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error running backup:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const get_backup_stats = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/backup/stats', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching backup stats:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const get_backup_runs = async (days = 7) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch(`/backup/runs?days=${days}`, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching backup runs:", err);
        return { message: err.message || 'An error occurred', status: 500 };
    }
};

export const restore_list_buckets = async (restorePassword) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/backup/restore/buckets', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}`, 'X-Restore-Password': restorePassword },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error listing restore buckets:", err);
        return { status: 500, data: { error: err.message } };
    }
};

export const restore_browse_files = async (restorePassword, bucket = null) => {
    try {
        const sessionToken = await getSessionUUID();
        const url = bucket ? `/backup/restore/browse?bucket=${encodeURIComponent(bucket)}` : '/backup/restore/browse';
        const response = await fetch(url, {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}`, 'X-Restore-Password': restorePassword },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error browsing restore files:", err);
        return { status: 500, data: { error: err.message } };
    }
};

export const run_restore = async (restorePassword, buckets = null, overwrite = false) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/backup/restore/run', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ restore_password: restorePassword, buckets, overwrite }),
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error running restore:", err);
        return { status: 500, data: { error: err.message } };
    }
};


// =====================================================
// Drivers Handbook
// =====================================================

export const get_drivers_handbook = async () => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/drivers_handbook', {
            method: 'GET',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error fetching drivers handbook:", err);
        return { status: 500, data: { error: err.message } };
    }
};

export const update_drivers_handbook = async (content) => {
    try {
        const sessionToken = await getSessionUUID();
        const response = await fetch('/dev/drivers_handbook', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${sessionToken}` },
            body: JSON.stringify({ content }),
        });
        const responseBody = await response.json();
        return { status: response.status, data: responseBody };
    } catch (err) {
        logger.error("Error saving drivers handbook:", err);
        return { status: 500, data: { error: err.message } };
    }
};
